import { LOGIN_CARD_BODY_CLASS, LoginCard } from "./login/LoginCard";

import { PROVIDER_PORTAL_MAIN_COLUMN_CLASS } from "./util/providerPortalMainColumn";
import { rebrandEnabled } from "./util/brandingFlag";

/** Confirmation shown after a password reset email is requested. */
const PasswordResetLinkSent = () => {
  if (rebrandEnabled()) {
    return (
      <LoginCard heading="Almost there! We've emailed you a password reset link.">
        <p className={LOGIN_CARD_BODY_CLASS}>
          Please click on the link from us in your email to reset your password.
        </p>
      </LoginCard>
    );
  }

  return (
    <div className={PROVIDER_PORTAL_MAIN_COLUMN_CLASS} id="terms_page">
      <h2 className="check-your-email-heading">
        Almost there! We've emailed you a password reset link.
      </h2>
      <div className="check-your-email-text">
        Please click on the link from us in your email to reset your password.
      </div>
    </div>
  );
};

export default PasswordResetLinkSent;
